 
 
 
 
 
 
 class UserRegister{
    constructor(){
        this.matrimony_Profile_For=null;
        this.name=null;
        this.gender=null;
        this.date_Of_Birth =null;
        this.mobile_Number=null;
        this.email_Id=null;
        this.password=null;
        this.religion=null;
        this.mother_Tongue=null;
        this.caste=null;
        this.sub_Caste=null;
        this.gothram=null;
        this.marital_Status=null;
        this.height=null;
        this.family_Status=null;
        this.family_Type=null;
        this.family_Values=null;
        this.any_Disability=null;
        this.highest_Education=null;
        this.employed_In=null;
        this.occupation=null;
        this.annual_Income=null;
        this.code = null;
        this.country = null;
        this.stateId = null;
        this.districtId = null;
        this.line_1 = null;
        this.line_2 = null;
       
}
}

export default UserRegister ;